import { render, staticRenderFns } from "./TribunalCourtItem.vue?vue&type=template&id=e07dec6a"
import script from "./TribunalCourtItem.vue?vue&type=script&lang=js"
export * from "./TribunalCourtItem.vue?vue&type=script&lang=js"
import style0 from "./TribunalCourtItem.vue?vue&type=style&index=0&id=e07dec6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports